<template>
    <div class="base-popup-dialog">
          <v-dialog class="v-dialog-box" v-model="value" @input="onCloseDialog" scrollable :persistent="persistent" :retain-focus="retainFocus" :max-width="maxBodyWidth">
               <v-card class="v-dialog-card">
                     <v-card-title class="headline teal white--text title-card popup-header noselect" >
                          <v-icon v-if="icon != ''" style="margin-right: 15px;">{{icon}}</v-icon>
                        {{title}}
                    </v-card-title>
                     <v-divider></v-divider>
                     <v-card-text class="v-dialog-card-text" :max-height="maxBodyHeight">
                         <slot name="dialogBody"></slot>
                    </v-card-text>
                     <v-divider></v-divider>
                     <slot name="dialogFooter"></slot>
               </v-card>
          </v-dialog>
    </div>
</template>
<script>
export default {
    name:"BasePopUpDialog",
    props:{
        value:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default:""
        },
        icon:{
            type:String,
            default:""
        },
        maxBodyWidth:{
            type:Number,
            default:600
        },
        maxBodyHeight:{
            type:Number,
            default:400
        },
        persistent:{
            type:Boolean,
            default:true
        },
        retainFocus:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        value(val){
            if(val){
                this.$nextTick(function(){
                    //set dialog to center
                    const dialog = document.querySelector(".v-dialog.v-dialog--active");
                    if (dialog != null){
                        dialog.style.left = null;
                        dialog.style.top = null;
                    }
                });
            }
        }
    },
    methods:{
        onCloseDialog(){
            this.$emit("input",false);
        },
    }
}
</script>
<style lang="scss" scoped>
.v-dialog.v-dialog--active .popup-header {
    cursor: grab;
}

.v-dialog.v-dialog--active .popup-header:active {
        cursor: grabbing;
}

.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
  }

</style>